import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../../features/auth/services/auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const accessToken = authService.accessToken;

  const authorizedRequest = accessToken
    ? request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
    : request;

  return next(authorizedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      const normalizedError = normalizeErrorResponse(error);

      if (normalizedError.status === 401) {
        authService.logout(false);
        void router.navigate(['/login']);
      }

      return throwError(() => normalizedError);
    }),
  );
};

function normalizeErrorResponse(error: HttpErrorResponse): HttpErrorResponse {
  if (typeof error.error !== 'string') {
    return error;
  }

  const trimmedError = error.error.trim();

  if (!trimmedError || !trimmedError.startsWith('{')) {
    return error;
  }

  try {
    return new HttpErrorResponse({
      error: JSON.parse(trimmedError) as unknown,
      headers: error.headers,
      status: error.status,
      statusText: error.statusText,
      url: error.url ?? undefined,
    });
  } catch {
    return error;
  }
}
